//Rushit: Custom JS added for all categories A-Z page.
class LinklistAZTable extends HTMLElement {
  constructor() {
    super();
    this.linklistAzTable = document.getElementById('haloLinklistAZTable');
    this.linklistAzWrapper = document.getElementById('haloLinklistAZWrapper');
    
    if(!this.linklistAzTable || !this.linklistAzWrapper) return;
    
    if(this.linklistAzTable.querySelector('a')){
      this.linklistAzTable.querySelectorAll('a').forEach((azButton) => {
        azButton.addEventListener('click', this.onClickHandler.bind(this));
      });
    }

    const allGroups = this.linklistAzWrapper.querySelectorAll('.linklist-az-group')
    allGroups.forEach(group => {
      const groupList = group.querySelector('.linklist-category')
      if (groupList == null) {
        group.classList.add('hide')
      }
    })
  }

  onClickHandler(event) {
    event.preventDefault();
    
    const box = this.linklistAzWrapper.getBoundingClientRect()
    const totalOffset = box.top + document.documentElement.scrollTop
    window.scrollTo({
      top: totalOffset,
      behavior: 'smooth'
    })

    this.linklistAzTable.querySelectorAll('li').forEach((element) =>{
      element.classList.remove('is-active');
    });
    
    event.target.closest('li').classList.add('is-active');

    var letter = event.target.getAttribute('data-href');
    
    this.linklistAzWrapper.querySelectorAll('.linklist-az-group').forEach((element) =>{
      element.classList.remove('is-active');
    });

    if (letter != undefined && letter != null) {
      this.linklistAzWrapper.classList.remove('active-all');
      const targetGroup = this.linklistAzWrapper.querySelector(`[data-letter="${letter}"]`);
      if (targetGroup) {
        targetGroup.classList.add('is-active');
      }
    } else {
      this.linklistAzWrapper.classList.add('active-all');
    }
  }
}

customElements.define('linklist-aztable-items', LinklistAZTable);